import * as React from "react";
const SvgRobot20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M0 2h20v13c0 .08-.003.161-.01.24A3.5 3.5 0 0 1 14.05 18h-8.1a3.5 3.5 0 0 1-5.94-2.76A3.04 3.04 0 0 1 0 15V2Zm18 10.337A3.5 3.5 0 0 0 13.035 16h-6.07A3.5 3.5 0 0 0 2 12.337V4h16v8.337ZM3.5 14a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM15 15.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgRobot20Px;
